export const FORBIDDEN_COUNTRY_CODES = ['IRN', 'CUB', 'SYR', 'PRK'];
export const DEFAULT_DEPRECATION_TIMESTAMPS = [1649263144395];
